<ng-container [formGroup]="group" *ngIf="dynamic && dynamic.format">
  <div *ngIf="AddressFields=='FULL'" class="form-group" [class.has-error]="adr_line1HasError | async">
    <label for="input-thoroughfare">Address 1</label>
    <input type="text" [class.is-invalid]="adr_line1HasError | async" class="form-control" id="input-thoroughfare" formControlName="adr_line1" placeholder="address line 1" required>
  </div>
  <div *ngIf="AddressFields=='FULL'" class="form-group">
    <label for="input-premise">Address 2</label>
    <input type="text" class="form-control" id="input-premise" formControlName="adr_line2" placeholder="address line 2">
  </div>
  <div class="form-group" [class.has-error]="adr_cityHasError | async" *ngIf="dynamic.format.used_fields.indexOf('locality') > -1">
    <label for="input-locality">{{ dynamic.format.locality_label }}</label>
    <input type="text" [class.is-invalid]="adr_cityHasError | async" class="form-control" id="input-locality" formControlName="adr_city" placeholder="{{ dynamic.format.locality_label.toLocaleLowerCase() }}" [required]="dynamic.format.required_fields.indexOf('locality') > -1">
  </div>
  <ng-container *ngIf="dynamic.format.used_fields.indexOf('administrative_area') > -1">
    <ng-container *ngIf="dynamic.administrative_areas; then administrative_area_select; else administrative_area_text"></ng-container>
  </ng-container>
  <ng-template #administrative_area_text>
    <div class="form-group" [class.has-error]="adr_intl_provinceHasError | async">
      <label for="input-administrative-area">{{ dynamic.format.administrative_area_label }}</label>
      <input type="text" [class.is-invalid]="adr_intl_provinceHasError | async" class="form-control" id="input-administrative-area" formControlName="adr_intl_province" placeholder="{{ dynamic.format.administrative_area_label.toLocaleLowerCase() }}" [required]="dynamic.format.required_fields.indexOf('administrative_area') > -1">
    </div>
  </ng-template>
  <ng-template #administrative_area_select>
    <div class="form-group" [class.has-error]="adr_stateHasError | async" *ngIf="dynamic.format.used_fields.indexOf('administrative_area') > -1">
      <label for="input-administrative-area">{{ dynamic.format.administrative_area_label }}</label>
      <select [bs3Class]="['form-control']" [bs4Class]="['form-select']"  [class.is-invalid]="adr_stateHasError | async" id="input-administrative-area" formControlName="adr_state" [required]="dynamic.format.required_fields.indexOf('administrative_area') > -1">
        <option *ngFor="let state of dynamic.administrative_areas" [ngValue]="state">{{ state.sta_name }}</option>
      </select>
    </div>
  </ng-template>
  <div class="form-group" [class.has-error]="adr_post_codeHasError | async" *ngIf="dynamic.format.used_fields.indexOf('postal_code') > -1">
    <label for="input-postal-code">{{ dynamic.format.postal_code_label }}</label>
    <input type="text" [class.is-invalid]="adr_post_codeHasError | async" class="form-control" id="input-postal-code" formControlName="adr_post_code" placeholder="{{ dynamic.format.postal_code_label.toLocaleLowerCase() }}" [required]="dynamic.format.required_fields.indexOf('postal_code') > -1">
  </div>
</ng-container>

<ng-container *ngIf="! dynamic || ! dynamic.format">
  <p class="hidden-xs hidden-sm">&nbsp;</p>
  <p class="hidden-xs hidden-sm">&nbsp;</p>
  <p class="hidden-xs">&nbsp;</p>
  <p class="hidden-xs">&nbsp;</p>
  <p class="hidden-xs">&nbsp;</p>
</ng-container>
